import { useEffect, useState } from "react";
import { api, fmtUsd, fmtPct, fmtTime } from "@/lib/api";
import { SectionTitle, Badge } from "@/components/Bits";

export default function TradeHistory() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const tick = async () => { try { setRows(await api.history(200) || []); } catch {} };
    tick(); const id = setInterval(tick, 6000); return () => clearInterval(id);
  }, []);

  return (
    <div className="p-6 space-y-6">
      <SectionTitle sub={`${rows.length} closed trades on this server.`}>Trade History</SectionTitle>
      <div className="bg-[#0F0F14] border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="history-table">
          <thead className="text-[10px] uppercase tracking-widest text-[#71717A]">
            <tr>
              <th className="text-left px-4 py-3">Closed</th>
              <th className="text-left px-4 py-3">Side</th>
              <th className="text-right px-4 py-3">Entry</th>
              <th className="text-right px-4 py-3">Exit</th>
              <th className="text-right px-4 py-3">Size</th>
              <th className="text-right px-4 py-3">Lev</th>
              <th className="text-right px-4 py-3">PnL</th>
              <th className="text-right px-4 py-3">PnL %</th>
              <th className="text-left px-4 py-3">Exit reason</th>
              <th className="text-left px-4 py-3">Conditions</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={10} className="px-4 py-8 text-center text-[#71717A]">No trades yet.</td></tr>
            ) : rows.map((t) => (
              <tr key={t.id} className="border-t border-border/60">
                <td className="px-4 py-3 font-mono text-xs text-[#A0A0AB]">{fmtTime(t.closed_at)}</td>
                <td className="px-4 py-3"><Badge kind={t.side === "LONG" ? "long" : "short"}>{t.side}</Badge></td>
                <td className="px-4 py-3 cell-num">${fmtUsd(t.entry_price)}</td>
                <td className="px-4 py-3 cell-num">${fmtUsd(t.exit_price || 0)}</td>
                <td className="px-4 py-3 cell-num">{Number(t.size).toFixed(6)}</td>
                <td className="px-4 py-3 cell-num">{t.leverage}x</td>
                <td className={`px-4 py-3 cell-num ${t.realized_pnl >= 0 ? "long-text" : "short-text"}`}>{t.realized_pnl >= 0 ? "+" : ""}${fmtUsd(t.realized_pnl)}</td>
                <td className={`px-4 py-3 cell-num ${(t.pnl_percent || 0) >= 0 ? "long-text" : "short-text"}`}>{fmtPct(t.pnl_percent || 0)}</td>
                <td className="px-4 py-3 text-xs text-[#A0A0AB]">{t.exit_reason || "—"}</td>
                <td className="px-4 py-3 text-xs text-[#A0A0AB] max-w-[280px] truncate" title={(t.strategy_conditions_triggered || []).join(" | ")}>
                  {(t.strategy_conditions_triggered || []).slice(0, 2).join(" | ") || "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
